import * as React from "react";
const SvgAccount = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: "16px",
	height: "19px",
	viewBox: "0 0 16 19",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props
}, /* @__PURE__ */ React.createElement("title", null, "Icon / Reg / Events Copy 2@2x"), /* @__PURE__ */ React.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ React.createElement("g", {
	id: "\\uD83D\\uDD04-Symbols",
	stroke: "none",
	strokeWidth: 1,
	fill: "none",
	fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("g", {
	id: "Component-/-Nav-Icon---Account",
	transform: "translate(-24.000000, -22.000000)",
	fill: "#696C6F"
}, /* @__PURE__ */ React.createElement("g", {
	id: "Icon-/-Reg-/-Account",
	transform: "translate(16.000000, 16.000000)"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M16,16.9803922 C11.5888,16.9803922 8,19.2627451 8,22.0682353 L8,24.8235294 L24,24.8235294 L24,22.0682353 C24,19.2627451 20.4112,16.9803922 16,16.9803922 Z M16,15.4117647 C18.6472,15.4117647 20.8,13.3011765 20.8,10.7058824 C20.8,8.11058824 18.6472,6 16,6 C13.3528,6 11.2,8.11058824 11.2,10.7058824 C11.2,13.3011765 13.3528,15.4117647 16,15.4117647 Z",
	id: "Shape"
})))));
export default SvgAccount;
